import jwtDecode from 'jwt-decode'
import { setAxiosHeader } from '../apiService/apiService'

export const isAuthenticated = () => {
    if (!localStorage.getItem('token')) return false

    setAxiosHeader(localStorage.getItem('token'))

    // const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    // const refreshToken = localStorage.getItem("refreshToken");

    return true
}

export const getUserFullname = () => {
    const token = localStorage.getItem('token')
    if (!token) return null

    const { unique_name, fullName } = jwtDecode(token)
    if (fullName) return fullName
    return unique_name
}
